<template>
  <v-row>
    <v-col>
      <div v-if="showCard">
        <CardsView
          :items="holidaysGroups"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard">
        <TableWithSearch
          :items="holidaysGroups"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="openConcept"
        max-width="600px"
        persistent
        @keydown.esc="reset(false)"
      >
        <FormGroupsHolidays
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :showDate="true"
          @showSnackbar="showAlert"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import holidaysGroups from "@/store/gruposDeFeriados/holidaysGroups";
import holidays from "@/store/gruposDeFeriados/holidays";
import date from "@/store/common/date";
import schedules from "@/store/horarios/schedules";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import FormGroupsHolidays from "./Form/FormGroupsHolidays.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    FormGroupsHolidays,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  props: {
    showCard: Boolean,
  },
  data() {
    return {
      title: this.$tc("holidayGroups.holidayGroups"),
      titleDelete: this.$tc("holidayGroups.toHolidayGroup"),
      isLoading: true,
      maxWidth: ["600px", "500px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      dataInputs: [
        {
          name: "name",
          label: this.$tc("holidayGroups.nameHolidayGroup"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("holidayGroups.rulesDataConcept"),
          ],
        },
      ],
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    try {
      await Promise.all([
        new Promise(async (resolve) => {
          let nameTable = this.title;
          try {
            await configTable.dispatch("getColumsTableName", nameTable);
            if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
              this.saveConfigColumns();
            }
          } catch (error) {
            console.error("Error occurred:", error);
            // Aquí puedes manejar el error de manera específica si lo necesitas
          }
          resolve(); // Aseguramos que la promesa se resuelva incluso si hay un error
        }),
        holidaysGroups.dispatch("getGroupsHolidays"),
        holidays.dispatch("getHolidays"),
        schedules.dispatch("getSchedules"),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    dataSelects() {
      return [
        {
          name: "holidays",
          label: this.$tc("holidayGroups.holidays"),
          data: [],
          items: this.holidays,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "schedules",
          label: this.$tc("holidayGroups.schedules"),
          data: [],
          items: this.schedules,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    holidaysGroups() {
      return holidaysGroups.state.holidaysGroups;
    },
    holidays() {
      return holidays.state.holidays;
    },
    schedules() {
      return schedules.state.schedules;
    },
    padding() {
      return holidaysGroups.state.paddingNav;
    },
    mode: {
      get() {
        return holidaysGroups.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openConcept: {
      get() {
        return holidaysGroups.state.openConcepts;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return holidaysGroups.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await holidaysGroups.dispatch("getGroupsHolidays");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    generatePayload(form) {
      const payload = {
        nombre: form.name,
      };

      if (form.holidays && form.holidays.length > 0) {
        payload.feriados = form.holidays;
      }

      if (form.schedules && form.schedules.length > 0) {
        payload.horarios = form.schedules;
      }

      return payload;
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addHolidayGroup(form) {
      const payload = this.generatePayload(form);
      payload.id = this.itemId;
      holidaysGroups.commit("setNewGroupHoliday", payload);
      holidaysGroups
        .dispatch("addGroupHoliday")
        .then(() => {
          this.showAlert(
            this.$tc("holidayGroups.addHolidayGroupAlert"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("holidayGroups.addErrorHolidayGroup"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },
    editHolidayGroup(form) {
      const payload = this.generatePayload(form);
      payload.id = this.itemId;
      holidaysGroups.commit("setEditGroupHoliday", payload);
      holidaysGroups
        .dispatch("editGroupHoliday")
        .then(() => {
          this.showAlert(
            this.$tc("holidayGroups.editHolidayGroupAlert"),
            "#82A1D0"
          );
          holidaysGroups.dispatch("getGroupsHolidays");
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("holidayGroups.errorEditHolidayGroupAlert"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },
    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addHolidayGroup(items);
          break;
        case "edit":
          this.editHolidayGroup(items);
          break;
        default:
          break;
      }
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      holidaysGroups.commit("setOpenConcept", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = [];
      });
    },
    async setEdit() {
      await holidaysGroups.dispatch("getGroupHolidayId", this.itemId);
      this.dataInputs[0].data = holidaysGroups.state.edit.nombre;
      this.dataSelects[0].data = holidaysGroups.state.edit.feriados.map(
        (feriado) => feriado.ferId
      );
      this.dataSelects[1].data = holidaysGroups.state.edit.horarios.map(
        (horario) => horario.horId
      );
      holidaysGroups.commit("setOpenConcept", true);
    },
    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          holidaysGroups.commit(
            "setMode",
            this.$tc("holidayGroups.addHolidayGroup")
          );
          holidaysGroups.commit("setOpenConcept", true);
          break;
        case "edit":
          this.itemId = item.id;
          holidaysGroups.commit(
            "setMode",
            this.$tc("holidayGroups.editHolidayGroup")
          );
          await this.setEdit(item);
          break;
        case "delete":
          holidaysGroups.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },
    deleteItem() {
      holidaysGroups.commit("setItemDelete", this.itemToDelete);
      holidaysGroups
        .dispatch("deleteGroupHoliday")
        .then(() => {
          this.openDelete = false;
          holidaysGroups.commit("setOpenDelete", false);
          this.showAlert(
            (this.textAlert = this.$tc("holidayGroups.deleteAlert")),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("holidayGroups.errorDeleteAlert"), "#ff8d58");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      holidaysGroups.commit("setOpenDelete", false);
    },
  },
};
</script>
